import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import modeloPath from '../../recursos/3d/QPMINI.glb';  // Ruta del modelo 3D
import hdrPath from '../../recursos/3d/default.hdr';

export const setupScene = (mountRef, modelo) => {
  console.log('Modelo recibido en setupScene:', modelo); 
  const modeloPath = require(`../../recursos/3d/${modelo}.glb`); // Usar el parámetro 'modelo' para determinar la ruta
      // Escena y cámara
  const scene = new THREE.Scene();
  let camera=null;
  try {

  camera = new THREE.PerspectiveCamera(45, mountRef.current.clientWidth / mountRef.current.clientHeight, 10, 5000);
 
  } catch (error) {
    console.log(error)
    return
  }

   camera.position.set(150, 20, 100); // Posición inicial de la cámara
  scene.add(camera);


  // Configuración del renderizador
  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setSize(mountRef.current.clientWidth, mountRef.current.clientHeight);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1;
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.shadowMap.enabled = true;
  mountRef.current.appendChild(renderer.domElement);

  // Controles de órbita
  const controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.autoRotate = false;
  controls.autoRotateSpeed = 2;
  controls.enablePan = false;
  
  controls.enableZoom = true;
  controls.maxPolarAngle = Math.PI / 1.9; // Restringir la rotación vertical

  // Cargar iluminación HDR (esto afecta la iluminación global de la escena)
  const manager = new THREE.LoadingManager();
  manager.onProgress = (url, itemsLoaded, itemsTotal) => {
    const progressVal = (itemsLoaded / itemsTotal) * 100;
    if (progressVal === 100) {
      console.log('Carga completada');
    }
  };

  new RGBELoader(manager)
    .setDataType(THREE.HalfFloatType)
    .load(hdrPath, (texture) => {
      texture.minFilter = THREE.LinearFilter;
      texture.magFilter = THREE.LinearFilter;
      texture.mapping = THREE.EquirectangularReflectionMapping;
      texture.needsUpdate = true;
      scene.environment = texture;
      texture.dispose();
    });

  // Cargar modelo GLTF
  const loader = new GLTFLoader(manager).setDRACOLoader(new DRACOLoader());

  
  loader.load(modeloPath, (gltf) => {
    const model = gltf.scene;
    model.position.set(0, -30, 0); // Ajustar la posición del modelo
    model.scale.set(20, 20, 20); // Ajustar la escala del modelo

    // Rotation
    model.rotation.y = Math.PI / 5;
   // model.rotation.x = Math.PI / 10; 

    // Asegurarse de que el modelo pueda recibir y proyectar sombras
    model.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });

    scene.add(model);

    // Ajuste de la cámara en función del tamaño del modelo
    const box = new THREE.Box3().setFromObject(model);
    const center = box.getCenter(new THREE.Vector3());


    const size = box.getSize(new THREE.Vector3());
    const maxDim = Math.max(size.x, size.y, size.z);
    const fov = camera.fov * (Math.PI / 180);
    const cameraZ = Math.abs(maxDim / 2 / Math.tan(fov / 2));
    camera.position.set(0, 1, cameraZ * 2.5);
    camera.lookAt(center);




  });

  // Iluminación básica (ambient light)
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
  scene.add(ambientLight);

  // Iluminación puntual (spotlight)
  const spotLight = new THREE.SpotLight(0xffffff, 15.52, 0, 0.414, 0, 0.72);
  spotLight.position.set(3.743, 13.692, 3.585);
  spotLight.castShadow = true;
  spotLight.shadow.intensity = 0.56;
  spotLight.shadow.radius = 7.72;
  spotLight.shadow.camera.fov = 47.44090543683216;
  spotLight.shadow.camera.near = 0.5;
  spotLight.shadow.camera.far = 500;
  scene.add(spotLight);

  // Objetivo de la luz (target para el spotlight)
  const targetObject = new THREE.Object3D();
  targetObject.position.set(0, 0, 0); // Ajustar la posición de objetivo si es necesario
  scene.add(targetObject);
  spotLight.target = targetObject;

  // Configurar el plano para recibir sombras
  const planeGeometry = new THREE.PlaneGeometry(100, 100);
  const planeMaterial = new THREE.ShadowMaterial({ opacity: 0.2 });
  const plane = new THREE.Mesh(planeGeometry, planeMaterial);
  plane.rotation.x = -Math.PI / 2;
  plane.position.y = -1.5;
  plane.receiveShadow = true;
  scene.add(plane);

  // Manejar el cambio de tamaño de la ventana
  const handleResize = () => {
    const width = mountRef.current.clientWidth;
    const height = mountRef.current.clientHeight;
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
    renderer.setSize(width, height);
  };

  window.addEventListener('resize', handleResize);
  handleResize(); // Llamado inicial para ajustar el tamaño basado en el contenedor

  // Bucle de renderizado
  const animate = () => {
    requestAnimationFrame(animate);
    controls.update();
    renderer.render(scene, camera);
  };
  animate();

  // Cleanup cuando el componente se desmonte
  return () => {
    window.removeEventListener('resize', handleResize);
    if (mountRef.current) {
      mountRef.current.removeChild(renderer.domElement);
    }
  };
};
